import { render, staticRenderFns } from "./AdTipsEditor.vue?vue&type=template&id=393b20ab&scoped=true&"
import script from "./AdTipsEditor.vue?vue&type=script&lang=js&"
export * from "./AdTipsEditor.vue?vue&type=script&lang=js&"
import style0 from "./AdTipsEditor.vue?vue&type=style&index=0&id=393b20ab&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "393b20ab",
  null
  
)

export default component.exports